import React from "react";
import { Modal } from "react-bootstrap";
import "../../css/rentals/rentals.css";

class RentalExtendModal extends React.Component {
  render() {
    const {
      show,
      rental,
      extendEndDate,
      isLoading,
      onClose,
      onEndDateChange,
      onConfirm,
    } = this.props;

    if (!show || !rental) return null;

    const productName = rental.product ? rental.product.designation : "Produit";
    const establishmentName = rental.establishment
      ? rental.establishment.name
      : "Établissement";
    const isFormValid = extendEndDate && extendEndDate.trim() !== "";

    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop={isLoading ? "static" : true}
        keyboard={!isLoading}
        centered
        size="md"
        className="rental-extend-modal"
        dialogClassName="modal-dialog-rounded"
      >
        <Modal.Header className="rental-modal-header-gradient">
          <Modal.Title className="rental-modal-title">
            <i className="fas fa-calendar-plus mr-2"></i>
            Prolonger la location
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="rental-modal-body">
          <div className="rental-modal-body-inner">
            <h5 className="rental-modal-product-name">
              Prolonger la durée de location
            </h5>
            <p className="rental-modal-form-hint">
              Prolongation de la location pour <strong>{productName}</strong> à{" "}
              <strong>{establishmentName}</strong>
            </p>
            <p className="rental-modal-form-hint">
              Cette action va changer le statut à "Actif" et mettre à jour la
              date de fin.
            </p>
          </div>

          <div className="row">
            <div className="col-12 mb-3">
              <label className="rental-modal-form-label rental-modal-form-label-required">
                Nouvelle date de fin
              </label>
              <input
                type="date"
                className="rental-modal-form-input"
                value={extendEndDate}
                onChange={onEndDateChange}
                disabled={isLoading}
                min={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="rental-modal-footer">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="rental-modal-btn-cancel"
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading || !isFormValid}
            className={`rental-modal-btn-primary ${
              isLoading || !isFormValid
                ? "rental-modal-btn-primary-disabled"
                : "rental-modal-btn-primary-enabled"
            }`}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span>Prolongation...</span>
              </>
            ) : (
              <>
                Prolonger
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RentalExtendModal;
